import { msg } from '@lingui/core/macro';

export const SHARED_CARD_INFO_DATES_ASSIGNED = msg`Assigned`;
export const SHARED_CARD_INFO_DATES_DUE = msg`Due`;
export const SHARED_CARD_INFO_DATES_COMPLETED = msg`Completed`;
export const SHARED_CARD_INFO_DATES_PASSED = msg`Passed`;
